/*
 *  IRIS Interactive
 *
 *  NOTICE OF LICENSE
 *  This source file is no subject to a specific license
 *  but it belongs to the company IRIS Interactive.
 *  You can contact IRIS Interactive at the following
 *  address: contact@iris-interactive.fr
 *
 *  @author      Lucas Roche
 *  @date        25/06/2021 11:39
 *  @copyright   Copyright (c) 2002-2021 IRIS Interactive, Inc. (http://www.iris-interactive.fr)
 */

import {
    getCookie,
    setCookie,
} from '@iris.interactive/handcook/public/scripts/support/cookie.support'

/**
 *
 */
export default class EcoBarComponent {
    ecoModeConfig // Données de l'éco mode
    ecoModeTooltip

    /**
     *
     */
    constructor() {
        if (document.querySelectorAll('[data-id="eco-bar"]').length > 0) {
            import(
                /* webpackChunkName: "scripts/hc_tooltip" */
                /* webpackMode: "weak" */
                '@iris.interactive/handcook/public/scripts/components/tooltip/tooltip.component'
            ).then(({ default: hc_tooltip }) => {
                this.ecoModeTooltip = hc_tooltip('[data-toggle="#eco-bar"]')
                this.ecoModeTooltip.disable()

                this.ecoModeConfig = getCookie(IRISCollectionTheme.cookieNameOfEcoMode)
                    ? JSON.parse(getCookie(IRISCollectionTheme.cookieNameOfEcoMode))
                    : null

                /*
                 * On enregistre une config par défaut pour chaque utilisateur
                 */
                if (!this.ecoModeConfig) {
                    this.ecoModeConfig = {
                        isEcoModeActive: IRISCollectionTheme.config.ecomodeActive ?? false,
                        isEcoBarHidden: !IRISCollectionTheme.config.ecomodeActive ?? false,
                    }
                    setCookie(
                        IRISCollectionTheme.cookieNameOfEcoMode,
                        JSON.stringify(this.ecoModeConfig),
                        7,
                    )
                    if (!this.ecoModeConfig.isEcoBarHidden) {
                        $('[data-id="eco-bar"]').toggleClass('eco-bar--hidden')
                    }
                }

                if (this.ecoModeConfig.isEcoBarHidden) {
                    this.ecoModeTooltip.enable()
                }

                if (true === this.ecoModeConfig.isEcoModeActive) {
                    fetch(IRISCollectionTheme.carbonApiUpdateViewRoute + window.location.href, {
                        mode: 'no-cors',
                    })
                }

                /*
                 *  A l'ouverture /  Fermeture de la barre de l'éco mode
                 *  On enregistre le status de la barre dans un cookie
                 */
                $('[data-toggle="#eco-bar"]').on('click', () => {
                    $('[data-id="eco-bar"]').toggleClass('eco-bar--hidden')

                    if ($('[data-id="eco-bar"].eco-bar--hidden').length === 0) {
                        this.ecoModeTooltip.disable()
                    } else {
                        this.ecoModeTooltip.enable()
                    }

                    this.ecoModeConfig.isEcoBarHidden = !this.ecoModeConfig.isEcoBarHidden
                    setCookie(
                        IRISCollectionTheme.cookieNameOfEcoMode,
                        JSON.stringify(this.ecoModeConfig),
                        7,
                    )
                })

                /*
                 * Dans le cas ou on a cliqué le switch de l'éco bar
                 * On enregistre le status cookie et on recharge la page
                 */
                const ecoBarSwitch = '[data-trigger="eco-bar-switch"]'
                $(ecoBarSwitch).on('click', () => {
                    $(ecoBarSwitch).toggleClass('eco-bar__switch--active')
                    $(ecoBarSwitch).css('pointer-events', 'none')

                    if (this.ecoModeConfig.isEcoModeActive) {
                        this.ecoModeConfig.isEcoModeActive = !this.ecoModeConfig.isEcoModeActive
                        this.ecoModeConfig.isEcoBarHidden = true
                    } else {
                        this.ecoModeConfig.isEcoModeActive = true
                        this.ecoModeConfig.isEcoBarHidden = false
                    }
                    setCookie(
                        IRISCollectionTheme.cookieNameOfEcoMode,
                        JSON.stringify(this.ecoModeConfig),
                        7,
                    )
                    window.location.reload()
                })
            })
        }
    }
}
